import { render } from "./FormSelectMultiBadge.vue?vue&type=template&id=3e18087a"
import script from "./FormSelectMultiBadge.vue?vue&type=script&lang=js"
export * from "./FormSelectMultiBadge.vue?vue&type=script&lang=js"

import "./FormSelectMultiBadge.vue?vue&type=style&index=0&id=3e18087a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/FormSelectMultiBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e18087a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e18087a', __exports__)) {
    api.reload('3e18087a', __exports__)
  }
  
  module.hot.accept("./FormSelectMultiBadge.vue?vue&type=template&id=3e18087a", () => {
    api.rerender('3e18087a', render)
  })

}


export default __exports__